var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGradientCircle = function SvgGradientCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 437,
    height: 212
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient-circle_svg__circle-gradient)",
    d: "M109.658 412.116c104.256 60.917 237.568 24.766 297.76-80.746s24.471-240.43-79.785-301.347C223.377-30.895 90.066 5.257 29.873 110.769c-60.191 105.512-24.47 240.429 79.785 301.347"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-circle_svg__circle-gradient",
    x1: 97.645,
    x2: 337.634,
    y1: 455.259,
    y2: 1.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2D0DB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2D870"
  })))));
};
export default SvgGradientCircle;